var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88628 8.00033C1.88628 11.3754 4.62232 14.1114 7.9974 14.1114C11.3725 14.1114 14.1085 11.3754 14.1085 8.00033C14.1085 4.62525 11.3725 1.88921 7.9974 1.88921C4.62232 1.88921 1.88628 4.62525 1.88628 8.00033ZM7.9974 0.666992C3.94731 0.666992 0.664062 3.95024 0.664062 8.00033C0.664062 12.0504 3.94731 15.3337 7.9974 15.3337C12.0475 15.3337 15.3307 12.0504 15.3307 8.00033C15.3307 3.95024 12.0475 0.666992 7.9974 0.666992ZM7.9974 3.72255C8.3349 3.72255 8.60851 3.99615 8.60851 4.33366V7.38921H11.6641C12.0016 7.38921 12.2752 7.66282 12.2752 8.00033C12.2752 8.33783 12.0016 8.61144 11.6641 8.61144H8.60851V11.667C8.60851 12.0045 8.3349 12.2781 7.9974 12.2781C7.65989 12.2781 7.38628 12.0045 7.38628 11.667V8.61144H4.33073C3.99322 8.61144 3.71962 8.33783 3.71962 8.00033C3.71962 7.66282 3.99322 7.38921 4.33073 7.38921H7.38628V4.33366C7.38628 3.99615 7.65989 3.72255 7.9974 3.72255Z",
    fill: "#818387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default __webpack_public_path__ + "static/media/plus-round.4401333b17f26abbacd94e8cf073e4df.svg";
export { ForwardRef as ReactComponent };